import React from 'react'

export const TagSettings = () => {
  return (
    <div className="empty-message">
      <p>No options available</p>
    </div>
  )
}
